import './DateSelector.scss';
import { useState, useEffect } from 'react';


function DateSelector(props) {
	
	const [selectedDate, setSelectedDate] = useState({start:null,end:null, year: '', month: ''});
	const [selectorOpen, setSelectorOpen] = useState(false);
	const [selectorMOpen, setSelectorMOpen] = useState(false);
	
	const setDate = (date_option, year) => {
		let dateRange;
		setSelectorMOpen(false);
		setSelectorOpen(false);
		if(date_option === 'All'){
			let startYear = new Date(year, 0, 1);
			let endYear = new Date(year, 12, 0);
			dateRange = {start:startYear, end:endYear, month:'All', year:year};
			setSelectedDate(dateRange)
		}else{
			let month_num = getMonthFromString(date_option);
			let startYear = new Date(year, month_num-1, 1);
			let endYear = new Date(year, month_num, 0);
			dateRange = {start:startYear, end:endYear, month:date_option, year:year};
			setSelectedDate(dateRange)
		}

		props.setActiveDate(dateRange);
	}
	useEffect(() => {
		setDate('All', props.possibleYears[0]);
	}, [props.possibleYears]);
	const setYear = (year) =>{
		setDate(selectedDate.month, year);
	}
	const setMonth = (month) =>{
		setDate(month, selectedDate.year);
	}
	const getMonthFromString = (mon) => {
		return new Date(Date.parse(mon +" 1, 2012")).getMonth()+1
	 }
	 const months = ['January','February','March','April','May','June','July','August','September','October','November','December' ];
	return (
    	<div className='DateSelector'>
			
			<button className=' mr-5' onClick={() => {setSelectorMOpen(!selectorMOpen);setSelectorOpen(false);}}>Month: {selectedDate.month}</button>
			
			<button className='' onClick={() => {setSelectorOpen(!selectorOpen);setSelectorMOpen(false);}}>Year: {selectedDate.year}</button>

			<div className={selectorMOpen ? "open date-slector-tab": "date-slector-tab"}>
					<button onClick={() => setMonth('All')} >All</button>
					{months.map((month, index) => {
						return <button key={index} onClick={() => setMonth(month)} >{month}</button>	
					})}
			
			</div>
			<div className={selectorOpen ? "open date-slector-tab": "date-slector-tab"}>
				{props.possibleYears.map((year, index) => {
					return <button key={index} onClick={() => setYear(year)} >{year}</button>
				})}					
				<hr />
				<div className='text-text-gray text-left'>
					<strong>Note:</strong> Incidents will only appear on map after they have been reported
				</div>
			</div>
		</div>
	);
}

export default DateSelector;
